/** @module Camunda/ProcessOnInstanceRenderer */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/card/AttributeCardRenderer",
	"csi/html",
	"csi/locale",
	"csi/widget/CountToggle",
	"csi/widget/NameValuePair",
	"csi/xml",
	"./main"
], function(declare, _, AttributeCardRenderer, html, locale, CountToggle, NameValuePair, xml, Camunda) {

	return declare(AttributeCardRenderer, {
		cardAttributesOnly: true,

		/**
		 * @override
		 * Specify anchor text for attribute card
		 */
		onAttributeCardParams: function(ctx, params) {
			const {queryResult} = ctx;
			const cache = ctx.cache;
			const process = ctx.getNode();
			const revision = cache.get(process.ProcessDefinition);
			const definition = cache.get(revision.__Parent__);

			params.anchorText = locale.getNodeName(definition, cache);
			params.attributeSpecs = null;
			params.onClick = function() {
				_.defer(function() {
					ctx.view.set("filmstripSelection", queryResult.id);
				});
			};
		},

		/**
		 * @override
		 * Render slim attribute card for current context with configured parameters
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			this.inherited(arguments);

			const process = ctx.getNode();
			const div = html.create("div", {
				"class": "csi-camunda-table-group-content"
			}, refNode, "after");

			if (Camunda.isProcessInstanceActive(process)) {
				// render running / completed tasks
				const tasks = ctx.cache.getNodes(process.Tasks);
				const active = _.where(tasks, {ActivityState: "CamundaActivityState:Started"});
				const group = [];

				new CountToggle({
					checked: true,
					count: active.length,
					countClass: "csi-camunda-running",
					group: group,
					label: locale.resource("CamundaRunningTasks"),

					onClick: function() {
						ctx.view.toggleCompletedTasks(process.$URL, false);
					}
				}).placeAt(div);

				new CountToggle({
					count: tasks.length - active.length,
					countClass: "csi-camunda-complete",
					group: group,
					label: locale.resource("CamundaCompletedTasks"),

					onClick: function() {
						ctx.view.toggleCompletedTasks(process.$URL, true);
					}
				}).placeAt(div);

			} else {
				const state = process.ActivityState;
				const label = locale.resource(state).toUpperCase();
				switch (state) {
					case Camunda.STATE_COMPLETED:
						new NameValuePair({
							"class": "csi-camunda-complete",
							name: label,
							separator: ""
						}).placeAt(div);
						break;
					case Camunda.STATE_SUSPENDED:
						new NameValuePair({
							"class": "csi-camunda-suspended",
							name: label,
							separator: ""
						}).placeAt(div);
						break;	
					case Camunda.STATE_CANCELLED:
						new NameValuePair({
							"class": "csi-camunda-canceled",
							name: label,
							separator: ""
						}).placeAt(div);
						break;
				}
			}

			return true;
		},

		/**
		 * @override
		 * There is no details card for task in process instance view
		 */
		toTooltip: function(ctx, h, tooltip) { }
	});
});
